<template>
  <div>

        <div id="home" class="banner-w3pvt d-flex">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 bnr-txt-w3pvt">
                        <div class="bnr-w3pvt-txt mt-sm-5">
                            <h6>Bem vindo ao meu Portfólio</h6>
                            <h2>Olá <span>meu nome é Artur Walemo</span></h2>
                            <h4>designer - developer - activista</h4>
                            <p class="mt-4"> Me dedico em fazer as pessoas acreditarem no impossivel através do código.
                              Gosto de encontrar problemas e criar possíveis soluções.</p>
                              <p class="mt-4"> Actulamente trabalho na empresa <a target="_blank" href="http://explicador.co.mz"><b style="color: #fff;">Explicador Inc, LDA</b></a> onde criamos uma solução educacional e Empresarial.</p>
                            <ul class="social_section_1info mt-4">
                                <li class="mb-2 facebook"><a target="_blank" href=https://web.facebook.com/arthurauthor.mabilo><span class="fa fa-facebook"></span></a></li>
                                <li class="mb-2 twitter"><a target="_blank" href="https://twitter.com/SitoeNelzio"><span class="fa fa-twitter"></span></a></li>
                                <li class="linkedin"><a target="_blank" href="https://www.linkedin.com/in/arthur-walemo-347002143/"><span class="fa fa-linkedin"></span></a></li>
                                <li class="pinterest"><a target="_blank" href="https://github.com/Mentorizer"><span class="fa fa-github"></span></a></li>
                            </ul>
                            <a href="#about" class="scroll bnr-btn mr-2">Saber mais </a>
                            <a href="#contact" class="scroll bnr-btn1">Contacte-me </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue